const state = {
  showLogin: false,
  showMenu: false
}

const mutations = {
  UPDATE_SHOW_LOGIN: (state, value) => {
    state.showLogin = value
  },
  UPDATE_SHOW_MENU: (state, value) => {
    state.showMenu = value
  }
}

const actions = {
  updateShowLogin (store, value) {
    store.commit('UPDATE_SHOW_LOGIN', value)
  },
  updateShowMenu (store, value) {
    store.commit('UPDATE_SHOW_MENU', value)
  }
}

const getters = {
  showLogin: state => state.showLogin,
  showMenu: state => state.showMenu
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/components/store/modules/header.js